import { useEffect, useState } from "react";
import { Card, Modal, Tag, message } from "antd";
import GoogleMapReact, { fitBounds } from 'google-map-react';
import { useAuth } from "../../../../../../store/AuthContext/AuthContext";
import { authRequest } from "../../../../../../common/request/authRequest";
import { CityMarker } from "./CityMarker";
import { DrawerPanelTitle, modalPanelStyles } from "../../../../common/Drawers/DrawerPanelTitle";

export const BenchmarkModal = (props: { benchmarkMap: any, onFinish: any }) => {    
            
    const [data, setData] = useState<any>();    
    const [zoom, setZoom] = useState(10);
    const [center, setCenter] = useState({ lat: 0, lng: 0 });
    
    const { projectGroup, logOut } = useAuth();       
    
    useEffect(() => {
        
        authRequest(
          `${process.env.REACT_APP_API}/projects/${projectGroup.project}/benchmark/current/?benchmarkId=${props.benchmarkMap.benchmarkId}`,
            { method: 'GET' }
            )
            .then((data) => {                
                
                setData(data);                            

                //if (data?.listOfCities?.length > 0) {
                    // Inicializa las coordenadas de los límites noroeste y sureste
                    let minLat = data.listOfCities[0].city.lat;
                    let maxLat = data.listOfCities[0].city.lat;
                    let minLng = data.listOfCities[0].city.lng;
                    let maxLng = data.listOfCities[0].city.lng;
        
                    data?.listOfCities?.map((record: { city: any; }) => {
                        minLat = Math.min(minLat, record.city.lat);
                        maxLat = Math.max(maxLat, record.city.lat);
                        minLng = Math.min(minLng, record.city.lng);
                        maxLng = Math.max(maxLng, record.city.lng);
                    });
        
                    //Obtiene los bounds para posicionar el mapa
        
                    const neswBounds: any = {
                        nw: { lat: minLat, lng: minLng },
                        se: { lat: maxLat, lng: maxLng }
                    };
        
                    const size = {
                        width: 500, 
                        height: 500, 
                    };
        
                    const { center, zoom } = fitBounds(neswBounds, size);

                    setCenter(center)
                    setZoom(zoom)
                //}                                              
            }).catch((error) => {
                if (error && error.status === 401) {
                    if (error.data.message === 'Google') {
                      //history.push('/vincular', { from: location });
                    } else {
                        message.error('Token expirado')
                        logOut();
                    }
                }
            });                       
    }, [projectGroup]); 
    
    return (
        <>
        <Modal
            width={'60%'}
            open={true}
            onOk={props.onFinish}            
            onCancel={props.onFinish}            
            footer={null}                           
            style={{ top: 20 }}
            {...modalPanelStyles}
            title={
                <DrawerPanelTitle
                    title={props.benchmarkMap.competitor}
                    extra={<Tag color='Teal'>{props.benchmarkMap.keyword}</Tag>}
                />
            }
        >   			
			<br/>
			
            <Card style={{position:'relative',margin:'0px 10px', boxSizing:'border-box', height:'97%', backgroundColor:'transparent', borderRadius:10}}>              

            {data?.listOfCities &&            
                <div style={{display:'flex', color:'slategray', justifyContent:'space-between'}}>
                    <div style={{ width: '100%', height: '650px', overflow: 'hidden', position: 'relative' }}>                              
                        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>                                                    
                            <h3 style={{marginLeft:'10px', color:'darkslategrey'}}><b>Posición dentro del TOP 20 por ciudad</b></h3>                                   
                        </div>
                        <GoogleMapReact
                            bootstrapURLKeys={{ key: "AIzaSyCtmjrbwFhUPNP-LfETh_aAKaFuZJhwDm4" }}
                            defaultCenter={{ lat: 0, lng: 0 }}
                            center={center}
                            defaultZoom={10}
                            zoom={zoom}
                            //onZoomAnimationStart={handleZoomAnimationStart}
                            //onZoomAnimationEnd={handleZoomAnimationEnd}                    
                            yesIWantToUseGoogleMapApiInternals
                            //options={{disableDefaultUI: true, gestureHandling: 'none'}}
                            //onGoogleApiLoaded={({ map, maps }: any) => handleApiLoaded(map, maps)}
                        >
                            {data.listOfCities.map((record: any, index: any) => (
                                <CityMarker 
                                lat={record.city.lat}
                                lng={record.city.lng}
                                city={record.city.city}
                                //onClick={() => handleMarkerClick(index, pos)}
                                places={record.places}    
                                allCompetitors={props.benchmarkMap.allCompetitors}
                                keyword={props.benchmarkMap.keyword}                                
                                competitor={props.benchmarkMap.competitor}/>                                
                            ))}
                        </GoogleMapReact>
                            
                        </div>                               
                    </div>                   
                }
            </Card>            
        </Modal>            									
                
        </>
    );
};

